"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var store_1 = require("../store/store");
exports.default = satcheljs_1.mutatorAction('setRegionalConfiguration', function setRegionalConfiguration(supportedCultures, supportedShortDateFormats, supportedShortTimeFormats) {
    var regionalOptions = store_1.default();
    regionalOptions.supportedCultures = supportedCultures;
    regionalOptions.supportedShortDateFormats = supportedShortDateFormats;
    regionalOptions.supportedShortTimeFormats = supportedShortTimeFormats;
});
//# sourceMappingURL=setRegionalConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/data/mutators/setRegionalConfiguration.js
// module id = 4921
// module chunks = 2